// extracted by mini-css-extract-plugin
export var lg = "_ie-4";
export var md = "_ie-3";
export var reactTimePickerInputGroupAmPm = "_ie-6";
export var redoTimePicker = "_ie-0";
export var sm = "_ie-2";
export var xl = "_ie-5";
export var xs = "_ie-1";